import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-add-new-element',
  templateUrl: './add-new-element.component.html',
  styleUrls: ['./add-new-element.component.scss']
})
export class AddNewElementComponent implements OnInit {

  @Input() url;
  @Input() source;
  template = 'template';
  constructor() {
  }

  ngOnInit(): void {
  }

}
